import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Projects.css";

/* LOGOS */
import logoSonny from "../assets/sonnys-logo.jpg";
import logoDataAnalyzer from "../assets/dataanalyser-logo.webp";
import logoBrandweave from "../assets/brand weave-logo.webp";
import logoBesta from "../assets/besta logo.png";
import logoParwah from "../assets/parwahconfectionery-logo.jpg";
import logoVaraha from "../assets/varaha logo.png";
import logoGuch from "../assets/guchdoors-logo.webp";
import logoOttoman from "../assets/ottoman-logo.webp";

import logoVinsa from "../assets/vinssa.webp";
import logoIBS from "../assets/IBSlogo.png";
import logoBanat from "../assets/banat-logo.webp";
import logoTalentMap from "../assets/tms logo.webp";
import logoVvcms from "../assets/vvcms-logo.webp";

// NEW LOGOS
import logoProtek from "../assets/protek logo.webp";
import logoApex from "../assets/apexlogo.png";
import logoAyrine from "../assets/ayrine logo.png";
import logoAzBlinds from "../assets/a-z.jpeg";
import logoSunImpex from "../assets/sunimpexlogo.png";
import logoGlandBotanica from "../assets/glandbotanicalogo.png";
import logoLotusLap from "../assets/lotus.png";

const Projects = () => {
  const wrapperRef = useRef(null);
  const trackRef = useRef(null);

  const [cloneCount, setCloneCount] = useState(3); // minimal start
  const [loopPx, setLoopPx] = useState(0); // scroll only the original set width

  const baseProjects = useMemo(
    () => [
      { id: 1, name: "Sonny's Indian Kitchen", logo: logoSonny, link: "https://sonnysindiankitchen.com/" },
      { id: 2, name: "Data Analyzer Pro", logo: logoDataAnalyzer, link: "https://dataanalyzerpro.com/" },
      { id: 3, name: "Brandweave Tech Solutions", logo: logoBrandweave, link: "https://brandweave.in/" },
      { id: 4, name: "Besta", logo: logoBesta, link: "https://besta.co.in/" },
      { id: 5, name: "Parwah's confectionery", logo: logoParwah, link: "https://parwahconfectionery.com/" },
      { id: 6, name: "Varaha silks", logo: logoVaraha, link: "https://varahasilks.in/" },
      { id: 7, name: "Guch Doors", logo: logoGuch, link: "https://guchdoors.com/" },
      { id: 8, name: "Ottoman Mitten", logo: logoOttoman, link: "https://ottomanmitten.com/" },
      { id: 9, name: "VINSA", logo: logoVinsa, link: "https://vinsatoothbrush.com/" },
      { id: 10, name: "IBS", logo: logoIBS, link: "https://ibs.ind.in/" },
      { id: 11, name: "BANAT", logo: logoBanat, link: "https://banatindia.com/" },
      { id: 12, name: "TALENT MAP", logo: logoTalentMap, link: "https://talentmap.in/" },
      { id: 13, name: "Protek Consult", logo: logoProtek, link: "https://protekconsult.com/" },
      { id: 14, name: "Apex Elevators", logo: logoApex, link: "https://apexlifts.in/" },
      { id: 15, name: "Ayrine", logo: logoAyrine, link: "https://ayrine.in/" },
      { id: 16, name: "a-z blinds", logo: logoAzBlinds, link: "https://atozblinds.in/" },
      { id: 17, name: "SunImpex", logo: logoSunImpex, link: "https://sunimpex-india.com/" },
      { id: 18, name: "Gland Botanica", logo: logoGlandBotanica, link: "https://www.glandbotanica.com/" },
      { id: 19, name: "Lotus Lap Public School", logo: logoLotusLap, link: "https://www.lotuslap.org/" },

      // ✅ Your ONE intentional duplicate near the end
      { id: 20, name: "Viveka Vardhini Creative Minds School", logo: logoVvcms, link: "https://vvcms.in/" },
    ],
    []
  );

  // ✅ Add a few clones of the START so after OTTOMAN duplicate, SONNY appears immediately
  const projects = useMemo(() => {
    const clones = baseProjects.slice(0, cloneCount).map((p, idx) => ({
      ...p,
      id: `clone-${p.id}-${idx}`,
    }));
    return [...baseProjects, ...clones];
  }, [baseProjects, cloneCount]);

  useEffect(() => {
    const measure = () => {
      const wrapper = wrapperRef.current;
      const track = trackRef.current;
      if (!wrapper || !track) return;

      const wrapperW = wrapper.getBoundingClientRect().width;

      // All items currently rendered
      const items = track.querySelectorAll(".carousel-item");

      // Width of ONE card "slot" (includes padding since item holds it)
      const first = items[0];
      if (!first) return;
      const itemW = first.getBoundingClientRect().width;

      // ✅ Clone just enough items so the next sequence is already visible at loop point
      // usually cards visible on screen + 1
      const visibleCards = Math.ceil(wrapperW / itemW);
      const neededClones = Math.min(Math.max(visibleCards + 1, 2), 6); // keep it minimal (2 to 6)
      setCloneCount(neededClones);

      // ✅ We want to scroll ONLY the original set (baseProjects length) width,
      // not including the clones.
      // loopPx = itemW * baseProjects.length
      setLoopPx(itemW * baseProjects.length);
    };

    // measure after first paint
    const t = setTimeout(measure, 0);
    window.addEventListener("resize", measure);

    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, [baseProjects.length]);

  return (
    <section className="projects-section" id="projects">
      <h2 className="projects-heading">OUR PROJECTS</h2>

      <div className="carousel-wrapper" ref={wrapperRef}>
        <div
          className="carousel-track"
          ref={trackRef}
          style={{ "--loop-x": `${loopPx}px` }}
        >
          {projects.map((project) => (
            <div className="carousel-item" key={project.id}>
              {project.link ? (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-card"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={project.logo}
                    alt={`${project.name} logo`}
                    className="project-logo"
                    draggable="false"
                  />
                  <h3 className="project-card-title">{project.name}</h3>
                </a>
              ) : (
                <div className="project-card">
                  <img
                    src={project.logo}
                    alt={`${project.name} logo`}
                    className="project-logo"
                    draggable="false"
                  />
                  <h3 className="project-card-title">{project.name}</h3>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
